import { render, staticRenderFns } from "./purchase-plan-publish-limit-dialog.vue?vue&type=template&id=8018fce2&scoped=true&"
import script from "./purchase-plan-publish-limit-dialog.vue?vue&type=script&lang=js&"
export * from "./purchase-plan-publish-limit-dialog.vue?vue&type=script&lang=js&"
import style0 from "./purchase-plan-publish-limit-dialog.vue?vue&type=style&index=0&id=8018fce2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8018fce2",
  null
  
)

export default component.exports